<template>
<div name="infomodal">

              <div class="grid grid-cols-1 mb-6 w-12/12 ml-4">
                <div>
                  <h1 class="font-bold mb-2 text-2xl">{{ challenge.title }}</h1>
                   <ul class="info-list mb-6 text-purple-600 w-11/12">
                    <li class="mb-2"><strong>Equipment required:</strong> <br/>
                      {{challenge.equipment}}</li>
                     <li><strong>Skills used:</strong> <br/>
                      {{challenge.skills}}</li>
                   </ul>
                </div>
                <div class="instruction text-sm w-11/12 "> 
                  <h3 class="font-bold">Instructions</h3>
                  <span v-html="challenge.instructions"></span>
                </div>

                <iframe class='sproutvideo-player w-6/12 mt-10' v-bind:src="videoURL()" frameborder='0' scrolling="no" style="width: 100%;height: 25vh;position: relative;" allowfullscreen></iframe>
              </div>

    </div>


</template>

<script>

export default {
  name: "infomodal",
  props: {
    challenge: {type: Object, required: true},
  },
  methods: {
    videoURL() {
      if (this.challenge.video_url === null) { return '' }
      return this.challenge.video_url + "?autoPlay=false&amp;playerTheme=light&amp;playerColor="
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
